var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 52,
    viewBox: "0 0 48 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2805_1281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1245 50.2095H32.8755",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9574 12.8965H43.9245C44.6297 12.8965 45.3061 13.1766 45.8048 13.6753C46.3035 14.174 46.5836 14.8504 46.5836 15.5556V38.977C46.5836 39.6822 46.3035 40.3586 45.8048 40.8573C45.3061 41.356 44.6297 41.6361 43.9245 41.6361H4.07542C3.37017 41.6361 2.6938 41.356 2.19511 40.8573C1.69642 40.3586 1.41626 39.6822 1.41626 38.977V15.5556C1.41626 14.8504 1.69642 14.174 2.19511 13.6753C2.6938 13.1766 3.37017 12.8965 4.07542 12.8965H18.2431",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6831 41.6362H20.317V50.2098H27.6831V41.6362Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3189 1.95421L17.2428 14.9315C17.2032 14.9882 17.1798 15.0545 17.1754 15.1235C17.1709 15.1924 17.1854 15.2613 17.2173 15.3226C17.2492 15.3838 17.2973 15.4352 17.3564 15.471C17.4155 15.5068 17.4832 15.5258 17.5523 15.5258H23.1627C23.2232 15.5258 23.2829 15.5404 23.3367 15.5683C23.3904 15.5962 23.4367 15.6366 23.4716 15.6861C23.5064 15.7356 23.5289 15.7928 23.537 15.8528C23.5451 15.9129 23.5387 15.974 23.5183 16.031L20.4264 24.6594C20.3955 24.7456 20.397 24.8399 20.4305 24.9251C20.4639 25.0102 20.5271 25.0803 20.6084 25.1224C20.6896 25.1644 20.7834 25.1755 20.8722 25.1537C20.961 25.1319 21.0389 25.0785 21.0914 25.0036L29.8885 12.4478C29.9271 12.3927 29.9502 12.3283 29.9556 12.2613C29.961 12.1943 29.9484 12.127 29.9191 12.0665C29.8899 12.006 29.8449 11.9543 29.789 11.917C29.7331 11.8796 29.6683 11.8578 29.6011 11.8539L24.0627 11.5305C24.0037 11.527 23.9463 11.5098 23.8952 11.4801C23.844 11.4505 23.8006 11.4092 23.7683 11.3597C23.736 11.3102 23.7158 11.2538 23.7093 11.195C23.7027 11.1362 23.7101 11.0768 23.7308 11.0214L26.9824 2.30272C27.0145 2.21659 27.0142 2.12171 26.9813 2.03585C26.9485 1.94999 26.8855 1.87904 26.8041 1.8363C26.7228 1.79355 26.6286 1.78195 26.5393 1.80365C26.4499 1.82536 26.3716 1.87889 26.3189 1.95421Z",
    stroke: "#3661FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39685 34.4517H39.7609",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39685 26.9058H39.7609",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6511 20.0811H39.7609",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39685 20.0811H21.5127",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2805_1281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 52,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons02);
export default __webpack_public_path__ + "static/media/icons-02.451fb17ba22f59a150327715f20962db.svg";
export { ForwardRef as ReactComponent };